import * as go from 'gojs';
import { PanelType } from 'store/units/types';
import {
  flowPropertiesGraph,
  flowPropertiesPxxTable,
  flowPropertiesSizeTable,
  warnings,
} from '../Panels/baseUnitPanel';
import { InfoPanel } from '../Panels/infoPanel';
import {
  particleSizeDistributionGraph,
  particleSizeDistributionList,
} from '../Panels/psdPanels';
import { locationBinding } from './node';
import {
  flowPropertiesGraphVisible,
  flowPropertiesPxxTableVisible,
  flowPropertiesSizeVisible,
  infoPanelVisible,
  psdGraphVisible,
  psdListVisible,
  warningPanelVisible,
} from './panelVisible';
import { panelMargin, roundedPanel } from '../Panels/baseUnitUtils';

const $ = go.GraphObject.make;

/**
 * Overriding the drag computation so that
 * it does not snap to the grid.
 */
const overrideDragComputation = (
  _thisPart: go.Part,
  newLoc: go.Point,
  _snappedLoc: go.Point,
) => {
  return newLoc;
};

const basePanel = (
  panel: go.Panel,
  locationSpot: go.Spot,
  visibleBinding: (param: any) => boolean,
  extra?: object,
) =>
  $(
    go.Node,
    {
      layerName: 'Foreground',
      cursor: 'move',
      alignment: new go.Spot(0, 0),
      avoidable: false,
      dragComputation: overrideDragComputation,
      locationSpot,
      selectionAdornmentTemplate: $(
        go.Adornment,
        'Spot',
        { layerName: 'Adornment' },
        $(go.Placeholder),
      ),
      ...extra,
    },
    new go.Binding('visible', '', visibleBinding),
    new go.Binding('isSelected', 'selected'),
    locationBinding(),
    $(
      go.Panel,
      'Spot',
      $(go.Panel, 'Auto', roundedPanel(), $(go.Panel, panelMargin(), panel)),
    ),
  );

const infoPanel = basePanel(InfoPanel, go.Spot.RightCenter, infoPanelVisible);

const warningPanel = basePanel(
  warnings,
  go.Spot.LeftCenter,
  warningPanelVisible,
);
const flowPropertiesGraphPanel = basePanel(
  flowPropertiesGraph,
  go.Spot.TopCenter,
  flowPropertiesGraphVisible,
  { resizable: true, resizeObjectName: 'FLOW_PROPERTIES' },
);

const flowPropertiesSizeTablePanel = basePanel(
  flowPropertiesSizeTable,
  go.Spot.TopCenter,
  flowPropertiesSizeVisible,
);

const flowPropertiesPxxTablePanel = basePanel(
  flowPropertiesPxxTable,
  go.Spot.TopCenter,
  flowPropertiesPxxTableVisible,
);

const particleSizeDistributionListPanel = basePanel(
  particleSizeDistributionList,
  go.Spot.TopRight,
  psdListVisible,
);

const particleSizeDistributionGraphPanel = basePanel(
  particleSizeDistributionGraph,
  go.Spot.LeftCenter,
  psdGraphVisible,
  { resizable: true, resizeObjectName: 'PSD_GRAPH' },
);

const PanelMap = {
  [PanelType.INFO_PANEL]: infoPanel,
  [PanelType.WARNINGS_PANEL]: warningPanel,
  [PanelType.FLOW_PROPERTIES_GRAPH_PANEL]: flowPropertiesGraphPanel,
  [PanelType.FLOW_PROPERTIES_SIZE_TABLE_PANEL]: flowPropertiesSizeTablePanel,
  [PanelType.FLOW_PROPERTIES_PXX_TABLE_PANEL]: flowPropertiesPxxTablePanel,
  [PanelType.PARTICLE_SIZE_DISTRIBUTION_LIST_PANEL]:
    particleSizeDistributionListPanel,
  [PanelType.PARTICLE_SIZE_DISTRIBUTION_GRAPH_PANEL]:
    particleSizeDistributionGraphPanel,
};

export const makePanel = (panelType: PanelType) => PanelMap[panelType];
